import React from 'react'

const ProductionPlanning = () => {
  return (
    <div>ProductionPlanning</div>
  )
}

export default ProductionPlanning